var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { FAS_CIRCLE_EXCLAMATION } from '../../../const/iconProps';
import { DeliveryMethodColumnContent, DeliveryMethodErrorContent, DeliveryMethodErrorWrapper, InputErrorWrapperLeft } from './subcomponents';
var DeliveryMethodHelperText = function (_a) {
    var deliveryMethodError = _a.deliveryMethodError, alertId = _a.alertId;
    var t = useTranslation().t;
    var stringKey = alertId.toLowerCase();
    var deliveryMethod = stringKey === 'syf_pay_later'
        ? 'syfPayLaterDeliveryMethod'
        : 'deliveryMethod';
    var deliveryMethodText = t("errorMessages.".concat(deliveryMethod));
    return (_jsxs(_Fragment, { children: [_jsx(InputErrorWrapperLeft, { children: deliveryMethodError && (_jsx(FontAwesomeIcon, { icon: FAS_CIRCLE_EXCLAMATION })) }), _jsx(DeliveryMethodErrorWrapper, __assign({ id: "delivery-method_helper-text".concat(alertId), "data-test": "DeliveryMethodErrorWrapper", "aria-live": "polite", role: "alert" }, { children: deliveryMethodError || (_jsxs(DeliveryMethodErrorContent, { children: [_jsx(DeliveryMethodColumnContent, { children: deliveryMethodText }), _jsx(DeliveryMethodColumnContent, { children: stringKey === 'syf_pay_later' &&
                                t('errorMessages.syfPayLaterSubText') })] })) }))] }));
};
export default DeliveryMethodHelperText;
